module.exports = __webpack_public_path__ + "02_mole.38475c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/02_mole.png
// module id = hJQH
// module chunks = 0